var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"navmenu navmenu-default navmenu-fixed-right offcanvas-sm"},[_c('div',{staticClass:"overlay"},[_vm._m(0),_c('div',{staticClass:"category"},[_c('category')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"navbar-toggle btn btn-x",attrs:{"type":"button","data-toggle":"offcanvas","data-target":".navmenu"}},[_vm._v(" ✕ ")])])
}]

export { render, staticRenderFns }